export enum ERfpStatus {
  Draft = 'draft',
  Active = 'active',
  Completed = 'completed',
}

export enum ERfpStatusLabel {
  draft = 'Черновик',
  active = 'Активный',
  completed = 'Завершен',
}
